import { render, staticRenderFns } from "./DriverAdd.vue?vue&type=template&id=db58b41a&scoped=true"
import script from "./DriverAdd.vue?vue&type=script&lang=js"
export * from "./DriverAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db58b41a",
  null
  
)

export default component.exports